import React, { useRef, useState } from 'react';
import { DataGrid } from 'devextreme-react';
import { 
    Paging, 
    Pager, 
    FilterRow, 
    HeaderFilter, 
    ColumnChooser, 
    Column, 
    Lookup,
    Editing,
    MasterDetail,
    Summary,
    Button as ButtonGrid,
    TotalItem} from 'devextreme-react/data-grid';
import { createStoreLocal } from '../../utils/proxy';
import Title from '../../components/shared/Title';
import BlockHeader from '../../components/shared/BlockHeader';
import { store } from '../../services/store';

import { _path } from "../../data/headerNavigation";
import { dataAccess, formatDate, formatDateTime, resources } from '../../data/app';
import { cellAsPayoff, cellRender, formatToMoney, padIdInfoData } from '../../utils/common';
import urlReport from '../../services/reportServices';
import useAuthorization from '../../hooks/useAuthorization';
import { billDialogAction } from '../../store/bill/billDialogReducer';
import Nuevo from './Nuevo';
import * as BillNuevo from '../../components/bill/Nuevo';

import { useDispatch, useSelector } from 'react-redux';
import { getConfig } from '../../data/bill';
import DetailTemplate from '../../components/bill/DetailTemplate';
import { onCellPreparedReceipt } from '../../components/bill/CellPrepared';

const BillxC = props => {

    const { clientId = 0 } = props;    

    const { authorized, auth } = useAuthorization([resources.facturacion, dataAccess.access ]);
    const [ dataDialog, setDataDialog ] = useState({ id: 0, billId: 0, open: false, client : '', balance : ''});

    const dispatch = useDispatch();    
    let refGrid = useRef();
    const { appInfo } = useSelector(store => store);


    const addMenuItems =(e) => {
        
        if (e.target == "content") {
            
            // e.items can be undefined
            if (!e.items) e.items = [];
 
            // Add a custom menu item
            if(e.rowIndex >= 0)
                e.items.push({

                    text: `Ver factura`,
                    icon : 'doc',
                    onItemClick: () => {

                        dispatch(billDialogAction({ open : true, id : e.row.data.id }));
                        
                    }
                    
                },{

                    text: `Imprimir factura`,
                    icon : 'print',
                    onItemClick: () => {
                        const report = urlReport();
                        report.print(`${report.billTicket(e.row.data.id)}`);
                    }
                    
                },{

                    text: `Anular factura`,
                    icon : 'remove',
                    disabled : !auth.toDelete,
                    onItemClick: () => {                        
                        refGrid.current.instance.deleteRow(e.rowIndex);                        

                    },
                    color : 'red'
                });

           
        }
    }

    const onRowPrepared = (e) => {
        if (e.rowType == 'data') {
            if (!e.data.active) 
                e.rowElement.classList.add('no-activo');
            
        }
    }

    const onToolbarPreparing = (e) => {  
        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Exportar a excel',
                icon:'xlsxfile',
                type:'success',
                stylingMode:"outlined",
                onClick: () =>  refGrid.current.instance.exportToExcel(false)
            }
        });
    }  

    // const onCellPrepared = e => {

    //     const cellsQuantity = ['payoff']
            
    //     if (e.rowType == 'data' && e.column.allowEditing) {
    //         if(cellsQuantity.includes(e.column.dataField))
    //             if(e.row.data.payoff)
    //                 e.cellElement.classList.add('pagada');
    //             else           
    //                 e.cellElement.classList.add('pendiente');  
                    
    //         if(e.column.dataField == 'id' && e.data.typeId == typesBill.factura)
    //             e.cellElement.classList.add('col-id-factura');  

    //         if(e.column.dataField == 'id' && e.data.typeId == typesBill.cotizacion)
    //             e.cellElement.classList.add('col-id-cotizacion'); 
    //     }
    
    // }

    const onSave = (e) => refGrid.current.instance.refresh();

    const extraParameter = clientId > 0 ? { key : 'clientId', value : clientId } : null;

    const title ='Facturas pendientes';

    const config = getConfig(2);

    const openDialog = e => {
        setDataDialog({ id: 0, billId: e.row.data.id, open: true, client : e.row.data.nombre, balance : e.row.data.balance});
    }

    const close = e =>{
        setDataDialog({ id: 0, billId: 0, open: false, client : '', balance : ''});
    }

    const padId = padIdInfoData(appInfo);

    
    return authorized(
        <div className="container">
            <Title title={title}/>
            <BlockHeader title={title}>
                {/* <CustomButton
                    type="default"
                    text={`Nueva ${config.text}`}
                    icon='plus'
                    onClick = {() => {
                        dispatch(billDialogAction({ open : true }));
                    }}
                /> */}
            </BlockHeader>
            <Nuevo onSave={onSave} config={config}/>
            <BillNuevo.default data={dataDialog} close={close} onSave={onSave}/>
            <DataGrid id="grid"
                ref={refGrid}
                selection={{ mode: 'single' }}
                dataSource={store({uri : { get : 'bill/cxc/get'}, extraParameter})}
                showBorders={true}
                showRowLines={true}
                allowColumnResizing={true}
                allowColumnReordering={true}
                rowAlternationEnabled={true}
                hoverStateEnabled={true}
                onContextMenuPreparing={addMenuItems}
                onRowPrepared={onRowPrepared}
                onToolbarPreparing={onToolbarPreparing}
                onCellPrepared={onCellPreparedReceipt}
                //onCellPrepared={onCellPrepared}
                // remoteOperations={{
                //     paging: true,
                //     filtering: true
                // }}
            >
                <Paging defaultPageSize={20} />
                <Pager
                    showInfo={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50]}
                />
                <FilterRow visible={true} />
                <HeaderFilter visible={true} />
                <ColumnChooser enabled={true} />
                <Column type="buttons" width={80}>
                    <ButtonGrid name="modificar" text="Pagar" onClick={openDialog}/>
                </Column>
                <Column dataField="numberBill" width={90} caption={`Factura #`} alignment="right" cellRender={padId} />          
                <Column dataField="date" caption="Fecha" dataType='date'  format={formatDate} width={100}/>               
                <Column dataField="nombre" caption="Cliente" visible={clientId == 0}/>
                <Column dataField="typeId" width={130} caption="Documento" visible={clientId == 0}>
                    <Lookup disabled={true} dataSource={createStoreLocal({name : 'billType'})} valueExpr="id" displayExpr="name" />
                </Column>                 
                <Column dataField="paymentTypeId" width={120} caption="Tipo pago">
                    <Lookup disabled={true} dataSource={createStoreLocal({name : 'billPaymentType'})} valueExpr="id" displayExpr="name" />
                </Column>                 
                {/* <Column dataField="active" width={100} caption="Activa" /> */}
                <Column dataField="payoff" width={100} caption='Pagada' dataType="boolean"  cellRender={cellAsPayoff}/>
                
                <Column dataField="total" width={120} cellRender={cellRender()} />
                <Column dataField="amount" caption="Pagado" width={120} cellRender={cellRender()} />
                <Column dataField="balance" caption="Pendiente" width={120} cellRender={cellRender()} />

                <Column dataField="createBy" caption='Creado por' width={100} visible={false} />
                <Column dataField="createAt" caption='Creado el' dataType='date'  format={formatDateTime} width={180} visible={false}/>
                <MasterDetail
                    enabled={true}
                    component={props => <DetailTemplate onSave={onSave} {...props}/>}
                />
                <Summary>                
                    <TotalItem
                        column="balance"
                        summaryType="sum" customizeText={data => `${formatToMoney(data.value)}`} />
                </Summary>
                <Editing
                    mode="popup"                 
                    allowDeleting={true}
                    useIcons={true}
                ></Editing>
            </DataGrid>
        </div>
    );
}

export default BillxC;
